var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ring",class:{ 'lds-ring-small': _vm.isSmall },staticStyle:{"display":"flex","justify-content":"center","align-items":"center","min-height":"30px"}},[_c('div'),_c('div'),_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }